export default __webpack_public_path__ + "resources/icons/d411-2998.png";